export enum ChartType {
	Area = 'area',
	Bar = 'bar',
	Bullet = 'bullet',
	BulletHorizontal = 'bulletHorizontal',
	BulletVertical = 'bulletVertical',
	Column = 'column',
	Donut = 'donut',
	Line = 'line',
	Scatter = 'scatter',
	Spline = 'spline',
	Pie = 'pie',
}

export enum ChartCardType {
	Bar = 'bar',
	Column = 'column',
	Donut = 'donut',
	Pie = 'pie',
}

export enum ChartInputDataFormatType {
	Space = 'space',
	Period = 'period',
	Comma = 'comma',
}
